import { HStack, Image, Text, Tag, Flex, Wrap, WrapItem } from "@chakra-ui/react"
import dayjs from 'src/lib/dayjs.config'

interface BlogAuthorProps {
    date: string
    name: string
    src: string
    tags: string[]
}

const TAG_COLORS = {
    "Product": "teal",
    "Use Cases": "purple",
}

const BlogAuthor = (props: BlogAuthorProps) => {
    return (
        <Flex justify='space-between' direction={{ base: 'column', xl: 'row' }}>
            <HStack spacing="2" display="flex" alignItems="center" fontSize='sm' mb={{ base: 1, xl: 0 }}>
                <Image
                    borderRadius="full"
                    boxSize="24px"
                    src={props.src}
                    alt={`Avatar of ${props.name}`}
                />
                <Text fontWeight="medium">{props.name}</Text>
                <Text>—</Text>
                <Text>{dayjs(props.date).format("LL")}</Text>
            </HStack>
            <Wrap>
                {
                    props.tags.map((tag) => <WrapItem key={tag}>
                        <Tag colorScheme={TAG_COLORS[tag]}>{tag}</Tag>
                    </WrapItem>)
                }
            </Wrap>
        </Flex>
    )
}
export default BlogAuthor;
